import React, { Component } from 'react';
// import AppBar from '@material-ui/core/AppBar';
import red from '@material-ui/core/colors/red';
import QueryString from 'query-string';
import { NavigationLink, TextField, AppBar, Button } from '../components';
import { ThemeImages, ThemeColors } from '../theme';
import { Typography } from '@material-ui/core';

class SetPassword extends Component {

  constructor(props) {
    super(props);

    const { token, userId } = QueryString.parse(props.location.search);

    this.state = {
      password: '',
      passwordConfirm: '',
      token,
      userId,
    };
  }

  setPassword = (e) => {
    this.setState({ password: e.target.value });
  }

  setPasswordConfirmation = (e) => {
    this.setState({ passwordConfirm: e.target.value });
  }

  keyPress = (event) => {
    if (event.key === 'Enter') {
      this.resetPassword();
      event.preventDefault();
      return false;
    }
    return true;
  }

  checkPassword = () => this.state.password === this.state.passwordConfirm &&
        this.state.password.length >= 6

  resetPassword = () => {
    if (this.state.password && this.state.password !== '' && this.state.passwordConfirm === this.state.password) {
      this.props.resetPassword({
        password: this.state.password,
        resetToken: this.state.token,
        userId: this.state.userId,
      });
    }
  }


  render() {
    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      marginTop: 'calc(50vh - 215px)',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
    };
    const formGroupStyle = {
      width: '100%',
      textAlign: 'center',
    };

    const errorContainerStyle = {
      backgroundColor: red[500],
      textAlign: 'center',
      color: 'white',
    };

    const error = !this.checkPassword()
            ? (<Typography style={{ color: red[500], textAlign: 'center', margin: 10 }}>Passwörter stimmen nicht überein oder
            Passwort ist zu kurz (min 6 Zeichen)</Typography>)
            : null;

    if (!this.state.token || this.state.token === '' || !this.state.userId || this.state.userId === '') {
      return (
        <div style={{ ...containerStyle, padding: 20, width: 500 }}>
          <h1>Ungültige Anfrage</h1>
          <p>Passwort-ResetToken und UserId werden für diesen Vorgang benötigt.</p>
        </div>
      );
    }

    const RequestErrorMessage = (props) => {
      if (!props.errorMessage) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>{props.errorMessage}</span>
        </div>
      );
    };

    const PasswordErrorMessage = () => {
      if (!this.state.confirmTouched || this.state.password === this.state.passwordConfirm) {
        return null;
      }

      if (this.state.password && this.state.password.length == 0) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>Passwörter stimmen nicht überein!</span>
        </div>
      );
    };


    return (

      <div style={containerStyle}>
        <div style={{ padding: 20 }}>
          <img src={ThemeImages.logoPath} alt="Logo" style={{ width: '100%' }} />
        </div>
        <AppBar
          title="Account aktivieren"
          typography={{
            textAlign: 'center',
            textTransform: 'uppercase',
            fontSize: 16,
            color: 'white',
          }}
                    // titleStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white', fontSize: 14 }}
          showMenuIconButton={false}
          style={{
            height: '80px',
            backgroundColor: ThemeColors.primary1Color,
            boxShadow: '',
            flexDirection: 'row',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        />
        <form onKeyPress={this.keyPress} >
          <div
            style={{
              ...formGroupStyle,
              padding: 10,
            }}
          >
            <RequestErrorMessage {...this.props} />
            <PasswordErrorMessage />
            <TextField
              autoFocus
              required
              type="password"
              placeholder="Passwort"
              value={this.state.password}
              onChange={this.setPassword}
            />
            <TextField
              autoFocus
              required
              type="password"
              placeholder="Passwort bestätigen"
              value={this.state.passwordConfirm}
              onChange={this.setPasswordConfirmation}
            />

          </div>
          <Button
            label="Passwort setzen"
            primary
            onClick={this.resetPassword}
            disabled={!this.checkPassword()}
            style={{
              width: '100%',
              backgroundColor:
                            ThemeColors.primary1Color,
            }}
            labelStyle={{ textAlign: 'center', color: 'white' }}
          />
          {this.state.confirmTouched ? error : null}
        </form>
      </div>
    );
  }
}


export default SetPassword;



// WEBPACK FOOTER //
// ./src/app/activateaccount/setpassword.js